import { ActionDropdownLink } from "./ActionDropdownLink"
import { ActionDropdownPageLink } from "./ActionDropdownPageLink"
import { ActionDropdownPortalLink } from "./ActionDropdownPortalLink"
import { ActionDropdownTOULink } from "./ActionDropdownTOULink"
import { ActionDropdownUMSLink } from "./ActionDropdownUMSLink"
import { ActionType } from "../../../base/types"
import Dropdown from "react-bootstrap/esm/Dropdown"
import { IPageAction } from "../../../base/models"

export const ActionDropdownItem = ({ action }: {
    action: IPageAction,
}) => {
    const { actions } = action

    switch (action.type) {
        case ActionType.Action:
            return <ActionDropdownPageLink action={action} />
        case ActionType.ActionLink:
            return <ActionDropdownLink action={action} />
        case ActionType.TOULink:
            return <ActionDropdownTOULink action={action} />
        case ActionType.UMSLink:
            return <ActionDropdownUMSLink action={action} />
        case ActionType.PortalLink:
            return <ActionDropdownPortalLink action={action} />
        case ActionType.ActionGroup:
            if (!action.actions)
                return <Dropdown.ItemText>{action.name}</Dropdown.ItemText>

            return (
                <Dropdown>
                    <Dropdown.Toggle id="dropdown-autoclose-true">
                        {action.name}
                    </Dropdown.Toggle>

                    {actions?.map(action => (<ActionDropdownItem
                        key={action.actionId}
                        action={action} />))}
                </Dropdown>)
    }
}
